import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgFor } from '@angular/common';
import { Kv } from '../../../../state/integration-tester.models';

@Component({
  selector: 'it-kv-editor',
  standalone: true,
  templateUrl: './it-kv-editor.component.html',
  styleUrls: ['./it-kv-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor],
})
export class ItKvEditorComponent {
  @Input() rows: Kv[] = [];

  @Output() updateKv = new EventEmitter<{ index: number; patch: Partial<Kv> }>();
  @Output() remove = new EventEmitter<{ index: number }>();
}
